import {
    ENTRY_INCOMING_RELATIONS_REQUESTED,
    ENTRY_INCOMING_RELATIONS_UPDATE_REQUESTED,
    ENTRY_INCOMING_RELATIONS_RECEIVED,
    ENTRY_INCOMING_RELATIONS_ERROR
} from '../actions/entryDetailIncomingRelations';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";
import {ENTRY_DETAIL_UNMOUNT} from "../actions/entryDetail";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|EntryIdAction|ReceiveRelationsAction|ReceiveEntryErrorAction} action
 * @return {RequestResult}
 */
export const entryDetailIncomingRelations = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case ENTRY_INCOMING_RELATIONS_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), null);
        case ENTRY_DETAIL_UNMOUNT:
            return new RequestResult(RequestState.getInstanceInit(), null);
        case ENTRY_INCOMING_RELATIONS_UPDATE_REQUESTED:
            return new RequestResult(RequestState.getInstanceUpdating(), state.data);
        case ENTRY_INCOMING_RELATIONS_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.relations, action.receivedAt);
        case ENTRY_INCOMING_RELATIONS_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
